import React from 'react';
import { Box } from '@mui/material';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { SourceCard } from '../SourceCard';
import { MessageContentWithSources } from '../../TextMessage';
import styles from './ContentWithSources.module.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

const CN = 'content-with-sources';
const sourcesClass = `${CN}__sources`;

interface ContentWithSourcesProps {
  messageContent: MessageContentWithSources;
}

export const ContentWithSources = ({ messageContent }: ContentWithSourcesProps): React.ReactElement => (
  <>
    <Markdown remarkPlugins={ [ remarkGfm ] }>
      {messageContent.text}
    </Markdown>
    <Box className={ cx(sourcesClass) }>
      {messageContent.sources?.map((item, index) => (
        <SourceCard source={ item } withBorder key={ index } />
      ))}
    </Box>
  </>
);
